var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 26.14"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".chat_svg__cls-1{fill:none;stroke:#1e2022;stroke-miterlimit:10;stroke-width:2px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chat_svg__Path",
    d: "M42.77 53v8l5.91-5h14.09V38h-26v18h6",
    className: "chat_svg__cls-1",
    transform: "translate(-35.77 -37.03)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.97h16M6 6.97h16",
    className: "chat_svg__cls-1"
  })));
};
export default SvgChat;